module.exports = {"amp":"&","apos":"'","gt":">","lt":"<","quot":"\""}


//////////////////
// WEBPACK FOOTER
// ./~/entities/maps/xml.json
// module id = ./node_modules/entities/maps/xml.json
// module chunks = 168707334958949